import { useReactiveVar } from '@apollo/client';
import { Stack, Text, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';
import { setFlowLayoutState } from '../../../Conditions';

export enum EdgeEnumValues {
  and = 'And',
  or = 'Or',
}
// @ts-ignore
export const ApproverLevelEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  ...rest
}) => {
  const flowLayoutState = useReactiveVar(setFlowLayoutState);
  const calloutId = useId(`customNode-And-${id}`);
  const theme = useTheme();
  // const { setEdges } = useReactFlow();
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    targetPosition:
      flowLayoutState === 'horizontal' ? Position.Left : Position.Top,
    sourcePosition:
      flowLayoutState === 'horizontal' ? Position.Right : Position.Bottom,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} type="step" />
      <circle r="5" fill={theme.palette.themeDark}>
        <animateMotion dur="5s" repeatCount="indefinite" path={edgePath} />
      </circle>
    </>
  );
};
